const menu = document.querySelector('.navbar-nav');
const icons = document.querySelector('.header__icons');
const headerImg = document.querySelector('.header__heading-link');
const mainBanner = document.querySelector('#MainContent .shopify-section:first-child');
const header = document.querySelector('.shopify-section-main-header');
const body = document.body;

let lastScrollTop = 0;

// Función para agregar o quitar clases del menú
function toggleWhiteMenu(add) {
	menu.classList.toggle("white-menu", add);
	icons.classList.toggle("white-menu", add);
	headerImg.classList.toggle("white-menu", add);
}

// Función para agregar el fondo del header
function toggleBackgroundHeader(add) {
	header.classList.toggle("background-header", add);
}

// Función para verificar si un elemento está visible en pantalla
function isElementVisible(el) {
	if (!el) return false;
	const rect = el.getBoundingClientRect();
	return rect.top <= window.innerHeight && rect.bottom >= 0;
}

function updateClasses() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	// Caso especial: Página de suscripciones
	if (body.classList.contains('template_page-subscriptions') && body.classList.contains('first-slide-subs')) {
		toggleWhiteMenu(true);
		return;
	}

	// Colecciones
	if (body.classList.contains('template_collection')) {
		const collectionBanner = document.querySelector('.yv-collection-banner');
		const hasImage = collectionBanner?.querySelector('img');

		if (hasImage && isElementVisible(collectionBanner)) {
			toggleWhiteMenu(true);
			toggleBackgroundHeader(false);
		} else {
			toggleWhiteMenu(false);
			toggleBackgroundHeader(true);
		}
		return;
	}

	// Casos con fondo fijo en el header
	const staticBackgroundTemplates = ['template_customers-login', 'template_404', 'template_product', 'template_', 'template_customers-', 'template_customers-addresses', 'template_customers-account'];
	if (staticBackgroundTemplates.some(cls => body.classList.contains(cls))) {
		if (scrollTop > lastScrollTop || scrollTop >= 10) {
			toggleBackgroundHeader(true);
		} else if (scrollTop === 0) {
			toggleBackgroundHeader(false);
		}
		lastScrollTop = scrollTop;
		return;
	}

	// Blog
	if (body.classList.contains('template_blog')) {
		const blogBanner = document.querySelector('.top_page_title');
		if (!isElementVisible(blogBanner)) {
			toggleBackgroundHeader(true);
		} else {
			toggleWhiteMenu(false);
			toggleBackgroundHeader(false);
		}
		return;
	}

	// Artículos y productos especiales
	if (['template_article', 'template_article-brew-guide', 'template_product-equipamiento'].some(cls => body.classList.contains(cls))) {
		const articleBanner = document.querySelector('.yv-blog-detail-banner');
		const hasImage = articleBanner?.querySelector('img');

		if (hasImage && isElementVisible(articleBanner)) {
			toggleWhiteMenu(true);
			toggleBackgroundHeader(false);
		} else {
			toggleWhiteMenu(false);
			toggleBackgroundHeader(true);
		}
		lastScrollTop = scrollTop;
		return;
	}

	// Página principal o banners genéricos
	if (mainBanner) {
		const hasImage = mainBanner.querySelector('img');
		const mainBg = mainBanner.querySelector('.yv-page-banner');
		const hasBackgroundImage = mainBg && window.getComputedStyle(mainBg).backgroundImage !== 'none';

		if ((hasImage || hasBackgroundImage) && isElementVisible(mainBanner)) {
			if (!body.classList.contains('slide-subs-is-on')) {
				toggleWhiteMenu(true);
				toggleBackgroundHeader(false);
			} else {
				toggleBackgroundHeader(true);
			}
		} else {
			toggleWhiteMenu(false);
			if (!mainBg || scrollTop > 10) {
				toggleBackgroundHeader(true);
			}
			if (scrollTop === 0) {
				toggleBackgroundHeader(false);
			}
		}
	}

	lastScrollTop = scrollTop;
}

// Ejecutar en carga y scroll
window.addEventListener('DOMContentLoaded', updateClasses);
window.addEventListener('scroll', updateClasses);


/* Collection filters */
function toggleFilters() {
	document.getElementById('filterSideBar').classList.toggle('open-filters');
	document.getElementById('filterHeading').classList.toggle('filters-heading-section-open')
	document.getElementById('yv-applied-filter-close').classList.toggle('show')
}
var filterHeading = document.getElementById('filterHeading');
if (filterHeading) {
	filterHeading.addEventListener('click', toggleFilters);
}


function closeFilters() {
	document.getElementById('filterSideBar').classList.remove('open-filters')
	document.getElementById('filterHeading').classList.remove('filters-heading-section-open')
	document.getElementById('yv-applied-filter-close').classList.remove('show')
}
var filterClose = document.getElementById('yv-applied-filter-close');
if (filterClose) {
	filterClose.addEventListener('click', closeFilters);
}


/* Filtrar en la página de collections (mostrar filtros activos) */

const checkboxes = document.querySelectorAll('.filter-checkbox');

if (checkboxes) {
	checkboxes.forEach(checkbox => {
		checkbox.addEventListener('click', () => {
			// Afegir classe al checkbox seleccionat
			checkbox.classList.toggle('filter-selected');

		});
	})
}

if (window.innerWidth > 768) {
	runFilters()
}
function runFilters() {
	// when clicking the input checkbox 
	var checkBoxes = document.querySelectorAll('input[type="checkbox"]');
	checkBoxes.forEach(function (checkbox) {
		checkbox.addEventListener('click', function () {
			// submit the form
			var form = document.querySelector('form.yv-collection-filter');
			if (form) {
				form.submit();
			}
		});
	});
}

/* Subscriptions Swiper Filter */

if (document.querySelector('body').classList.contains('template_page-subscriptions')) {
	runSubsFiltering()
}
function runSubsFiltering() {
	var swiperThumbs = new Swiper(".swiper-thumbs", {
		spaceBetween: 10,
		slidesPerView: 5,
		freeMode: true,
		watchSlidesProgress: true,
	});
	const swiper = new Swiper('.swiper-filters', {
		spaceBetween: 0,
		normalizeSlideIndex: true,
		effect: "fade",
		slidesPerView: 1,
		watchSlidesVisibility: true,
		allowTouchMove: false,
		navigation: {
			nextEl: '.button-next',
		},
		thumbs: {
			swiper: swiperThumbs,
		},
		on: {
			slideChange: function () {
				const activeSlide = swiper.slides[swiper.activeIndex];

				if (activeSlide.classList.contains('slide-quantity')) {
					subsProductDetails();
				}
			}
		}
	});


	/* events onload */
	const buttonNext = document.querySelector('.button-next');
	const startButton = document.querySelector('.start');
	const swiperThumbsContainer = document.querySelector('.swiper-thumbs');
	let filter = null;
	const clics = [];

	swiperThumbsContainer.classList.add('hidden');

	if (buttonNext) {
		buttonNext.classList.add('on-first-slide');
	}

	if (startButton) {
		startButton.addEventListener('click', () => {
			swiper.slideTo(1);
		});
	}

	// guardar les opcions seleccionades al primer slide
	const options = document.querySelectorAll(".option");
	options.forEach(option => {
		option.classList.remove('selected');
		option.addEventListener("click", function () {

			options.forEach(opt => opt.classList.remove('selected'));
			option.classList.add('selected');

			filter = option.getAttribute('data-option');
			clics.push(filter);

			if (swiper.activeIndex === 1) {
				const productCards = document.querySelectorAll('.product-card');
				productCards.forEach(productCard => {
					const tueste = productCard.getAttribute('product-option');
					if (tueste === filter) {
						productCard.classList.add("match");
					} else {
						productCard.classList.remove("match");
					}
				});
			}
		});
	});

	// variacions a cada slide
	swiper.on('slideChange', function () {

		/* enable / disable botó Next */
		const currentSlideIndex = swiper.activeIndex;

		// Ocultar el botón de "Next" en todos los slides excepto en el slide 3 cuando el filtro es "custom"
		const buttonNext = document.querySelector('.button-next');
		if (buttonNext) {
			if (currentSlideIndex === 3 && filter === "custom") {
				buttonNext.classList.remove('hidden');
			} else {
				buttonNext.classList.add('hidden');
			}
		}

		// Verificar si se debe pasar al siguiente slide al hacer clic en .clickable
		const currentSlideClickableElements = swiper.slides[currentSlideIndex].querySelectorAll('.clickable-element');
		currentSlideClickableElements.forEach(element => {
			element.addEventListener('click', () => swiper.slideTo(currentSlideIndex + 1));
		});



		/* cada slide specifics */
		if (swiper.activeIndex === 0) {
			buttonNext.classList.add('on-first-slide');
			swiperThumbsContainer.classList.add('hidden');
			body.classList.remove('slide-subs-is-on');

		} else {
			buttonNext.classList.remove('on-first-slide');
			swiperThumbsContainer.classList.remove('hidden');
			body.classList.add('slide-subs-is-on');
		}

		if (swiper.activeIndex === 1) {

			menu.classList.remove("white-menu");
			icons.classList.remove("white-menu");
			headerImg.classList.remove("white-menu");
			header.classList.remove("background-header");


		} else if (swiper.activeIndex === 2) {

		} else if (swiper.activeIndex === 3) {
			// console.log(filter);
			if (filter === 'custom') {
				const productCards = document.querySelectorAll('.product-card.match');

				const slide = document.querySelector('.slide-choose');
				const collections = slide.querySelectorAll('.collection');
				/* mostrar títol corresponent  */
				const titles = slide.querySelectorAll('.choose-title');
				titles.forEach(title => {
					title.classList.add('hidden');
				})
				slide.querySelector('.title-custom').classList.remove('hidden');

				/* mostrar text corresponent  */
				const intros = slide.querySelectorAll('.choose-intros');
				intros.forEach(intro => {
					intro.classList.add('hidden');
				})
				slide.querySelector('.intro-custom').classList.remove('hidden');

				/* mostrar options corresponents  */
				const options = slide.querySelectorAll('.collection-options');
				options.forEach(option => {
					option.classList.add('hidden');
				})
				slide.querySelector('.options-custom').classList.remove('hidden');


				/* mostrar collection de tú eliges segons el filtre seleccionat */
				collections.forEach(collection => {
					const collectionData = collection.getAttribute('data-collection');

					if (collectionData) {
						let hasMatch = false;
						productCards.forEach(productCard => {
							const productOption = productCard.getAttribute('product-option');

							if (productOption && collectionData.includes(productOption)) {
								hasMatch = true;
							}
						});

						if (hasMatch) {
							collection.classList.add('show');
						} else {
							collection.classList.remove('show');
						}

						const products = collection.querySelectorAll('.product');
						products.forEach(product => {
							const productBtn = product.querySelector('.add-to-subs');

							if (productBtn) {
								productBtn.addEventListener('click', (event) => {
									event.stopPropagation();

									product.classList.toggle('product-selected');

									const clickedText = productBtn.getAttribute('data-seleccionado');
									productBtn.textContent = clickedText;

									hightlightMatchedProducts()
								});
							}
						});
					}
				});
				function hightlightMatchedProducts() {
					const toDisplayProducts = document.querySelectorAll('.product-subscription');
					const matchedProductCards = document.querySelectorAll('.product.product-selected');

					matchedProductCards.forEach(productCard => {
						const dataId = productCard.getAttribute('product-id');
						// console.log(dataId);

						toDisplayProducts.forEach(toDisplayProduct => {
							const displayProductId = toDisplayProduct.getAttribute('product-id');
							if (displayProductId === dataId) {
								toDisplayProduct.classList.add('highlight');
							}
						});
					});
				}

			} else if (filter == "te-sorprendemos") {

				/* canvi de títol principal segons tipus de subscripció */
				const slide = document.querySelector('.slide-choose');
				/* mostrar títol corresponent  */
				const titles = slide.querySelectorAll('.choose-title');
				titles.forEach(title => {
					title.classList.add('hidden');
				})
				slide.querySelector('.title-sorpresa').classList.remove('hidden');

				/* mostrar text corresponent  */
				const intros = slide.querySelectorAll('.choose-intros');
				intros.forEach(intro => {
					intro.classList.add('hidden');
				})
				slide.querySelector('.intro-te-sorprendemos').classList.remove('hidden');

				/* mostrar options corresponents  */
				const options = slide.querySelectorAll('.collection-options');
				options.forEach(option => {
					option.classList.add('hidden');
				})
				slide.querySelector('.options-te-sorprendemos').classList.remove('hidden');

				/* matchear productes */
				const productCards = document.querySelectorAll('.product-card');
				productCards.forEach(productCard => {
					const titleElement = productCard.querySelector('.title');
					if (titleElement) {
						const titleText = titleElement.textContent || titleElement.innerText;
						if (titleText.includes(filter)) {
							productCard.classList.add('subs-match');

						}
					}
				});

				/* guardar producte per la next slide */
				const toDisplayProducts = document.querySelectorAll('.product-subscription');
				const matchedProductCards = document.querySelectorAll('.product-card.subs-match.match');

				matchedProductCards.forEach(productCard => {
					const dataId = productCard.getAttribute('product-id');

					toDisplayProducts.forEach(toDisplayProduct => {
						const displayProductId = toDisplayProduct.getAttribute('product-id');
						if (displayProductId === dataId) {
							toDisplayProduct.classList.add('highlight');
						}
					});
				});

				swiper.slideTo(4);

			} else if (filter == "always-fresh") {
				const slide = document.querySelector('.slide-choose');
				/* mostrar títol corresponent  */
				const titles = slide.querySelectorAll('.choose-title');
				titles.forEach(title => {
					title.classList.add('hidden');
				})
				slide.querySelector('.title-fresh').classList.remove('hidden');

				/* mostrar text corresponent  */
				const intros = slide.querySelectorAll('.choose-intros');
				intros.forEach(intro => {
					intro.classList.add('hidden');
				})
				slide.querySelector('.intro-always-fresh').classList.remove('hidden');

				/* mostrar options corresponents  */
				const options = slide.querySelectorAll('.collection-options');
				options.forEach(option => {
					option.classList.add('hidden');
				})
				slide.querySelector('.options-always-fresh').classList.remove('hidden');

				/* matchear productes */
				const productCards = document.querySelectorAll('.product-card');
				productCards.forEach(productCard => {
					const titleElement = productCard.querySelector('.title');
					if (titleElement) {
						const titleText = titleElement.textContent || titleElement.innerText;
						if (titleText.includes(filter)) {
							productCard.classList.add('subs-match');

						}
					}
				});

				/* guardar producte per la next slide */
				const toDisplayProducts = document.querySelectorAll('.product-subscription');
				const matchedProductCards = document.querySelectorAll('.product-card.subs-match.match');

				matchedProductCards.forEach(productCard => {
					const dataId = productCard.getAttribute('product-id');

					toDisplayProducts.forEach(toDisplayProduct => {
						const displayProductId = toDisplayProduct.getAttribute('product-id');
						if (displayProductId === dataId) {
							toDisplayProduct.classList.add('highlight');
						}
					});
				});

				swiper.slideTo(4);

			}

		} else if (swiper.activeIndex === 4) {


			const highlightedProducts = document.querySelectorAll('.product-subscription.highlight');

			highlightedProducts.forEach((highlightedProduct) => {
				const form = highlightedProduct.querySelector('.subs-product-form');

				if (form) {
					buildVariant(form, highlightedProduct);
				}
			});

			function buildVariant(form, highlightedProduct) {
				const optionSelectors = highlightedProduct.querySelectorAll('input.product-option');
				const productDataElement = document.getElementById('product-data');
				const productData = JSON.parse(productDataElement.getAttribute('data-product'));

				function loadDefaultVariant() {
					const defaultVariant = productData.variants[0];
					updatePriceAndSubscription(defaultVariant);
					setVariantId(defaultVariant.id);
				}

				function updateVariant() {
					let selectedOptions = [];

					optionSelectors.forEach((selector) => {
						if (selector.checked) {
							selectedOptions.push(selector.value);
						}
					});

					// Buscar variante que coincida parcialmente con las opciones seleccionadas
					const matchedVariant = productData.variants.find((variant) => {
						return selectedOptions.every((opt, index) => variant.options[index] === opt || !selectedOptions[index]);
					});

					if (matchedVariant) {
						updatePriceAndSubscription(matchedVariant);
						setVariantId(matchedVariant.id);
					}
				}

				function updatePriceAndSubscription(variant) {
					const priceElement = highlightedProduct.querySelector('.item-price');
					const subscriptionElement = highlightedProduct.querySelector('.item-subscription');

					if (priceElement) {
						const scaledPrice = variant.price / 100;
						const formattedPrice = new Intl.NumberFormat('de-DE', {
							style: 'currency',
							currency: 'EUR',
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(scaledPrice);
						priceElement.innerHTML = formattedPrice;
					} else {
						console.error('.item-price element not found');
					}

					if (subscriptionElement) {
						subscriptionElement.innerHTML = variant.options[1] || ''; // Segunda opción como suscripción
					} else {
						console.error('.item-subscription element not found');
					}
				}

				function setVariantId(variantId) {
					const variantIdDiv = highlightedProduct.querySelector('#variantId');
					if (variantIdDiv) {
						variantIdDiv.innerHTML = '';

						const inputElement = document.createElement('input');
						inputElement.classList.add('hidden');
						inputElement.setAttribute('type', 'text');
						inputElement.setAttribute('name', 'id');
						inputElement.setAttribute('value', variantId);

						variantIdDiv.appendChild(inputElement);
					} else {
						console.error('#variantId element not found');
					}
				}

				optionSelectors.forEach((selector) => {
					selector.addEventListener('change', updateVariant);
				});

				loadDefaultVariant();
			}
		}
		/* afegir visited class a les thumbs per indicar progress */
		swiperThumbs.slides.forEach((slide, index) => {
			if (index < swiper.activeIndex) {
				slide.classList.add('visited');
			} else if (index === swiper.activeIndex) {
				slide.classList.remove('visited');
			} else {
				slide.classList.remove('visited');
			}
		});
	});
}

/* Product Details */
function subsProductDetails() {
	// Seleccionamos todos los bloques .product-subscription
	const subscriptionBlocks = document.querySelectorAll('.product-subscription');

	subscriptionBlocks.forEach(block => {
		// Solo activamos listeners dentro del bloque que tenga .highlight
		if (!block.classList.contains('highlight')) return;

		console.log('hello')

		const radioInputs = block.querySelectorAll('.select-peso input[type="radio"]');
		const detailsWrapper = block.querySelector('.details-wrapper');
		const sellingPlanWrappers = block.querySelectorAll('.selling_plan_wrapper');

		if (!detailsWrapper || sellingPlanWrappers.length === 0) return;

		radioInputs.forEach(input => {
			input.addEventListener('change', () => {
				console.log('hello');

				detailsWrapper.classList.add('show-freq');

				sellingPlanWrappers.forEach(wrapper => {
					wrapper.classList.remove('hidden');
				});
			});
		});
	});
}